



























































































import Vue from 'vue'
interface HotKeys {
    action?: string
    shortcut?: string
    shortcut2?: string
    shortcut2Hidden?: boolean
    heading?: boolean
    headingText?: string
}
export default Vue.extend({
    computed: {
        hotKeysList() {
            // List of hotkeys and there actions to be put onto the popup
            const listOfHotKeys: HotKeys[] = [
                // Inbox hotkeys
                {
                    heading: true,
                    headingText: 'Inbox Shortcuts - Conversation Feed'
                },
                {
                    action: 'Highlight Search',
                    shortcut: 'ctrl',
                    shortcut2: '/',
                    shortcut2Hidden: false
                },
                {
                    action: 'Toggle Conversation Status Between Open and Closed',
                    shortcut: 'shift',
                    shortcut2: 'E',
                    shortcut2Hidden: false
                },
                {
                    action: 'Mark as New',
                    shortcut: 'shift',
                    shortcut2: 'N',
                    shortcut2Hidden: false
                },
                {
                    action: 'Activate/Deactivate Multi-Select',
                    shortcut: 'shift',
                    shortcut2: 'S',
                    shortcut2Hidden: false
                },
                {
                    action: 'Open/Close Contact Profile',
                    shortcut: 'P',
                    shortcut2Hidden: true
                },
                {
                    action: 'Select/Unselect Conversation',
                    shortcut: 'X',
                    shortcut2Hidden: true
                },
                {
                    heading: true,
                    headingText: 'Inbox Shortcuts - Message Box'
                },
                {
                    action: 'Begin a Reply to the Selected Message Channel',
                    shortcut: 'R',
                    shortcut2Hidden: true
                },
                {
                    action: 'Send Message',
                    shortcut: 'shift',
                    shortcut2: 'enter',
                    shortcut2Hidden: false
                },
                {
                    action: 'Deselect Message Compose Box',
                    shortcut: 'ctrl',
                    shortcut2: 'shift',
                    shortcut2Hidden: false
                },
                // Global hotkeys
                {
                    heading: true,
                    headingText: 'Global Shortcuts'
                },
                {
                    action: 'Select Back Button',
                    shortcut: 'ctrl',
                    shortcut2: '[',
                    shortcut2Hidden: false
                },
                {
                    action: 'Open/Close Navigation',
                    shortcut: 'ctrl',
                    shortcut2: 'Q',
                    shortcut2Hidden: false
                },
                {
                    action: 'Navigate Up/Down List',
                    shortcut: 'J/K',
                    shortcut2: '↑/↓',
                    shortcut2Hidden: false
                },
                {
                    action: 'Select Active List Item',
                    shortcut: 'enter',
                    shortcut2: 'space',
                    shortcut2Hidden: false
                },
                {
                    action: 'Save Input',
                    shortcut: 'command',
                    shortcut2: 'enter',
                    shortcut2Hidden: false
                },
                {
                    action: 'Open and Close Shortcuts Menu',
                    shortcut: 'ctrl',
                    shortcut2: 'm',
                    shortcut2Hidden: false
                }
            ]

            return listOfHotKeys
        },
        // Gets only our inbox related hotkeys and headers from the array
        inboxHotKeys(): HotKeys[] {
            return this.hotKeysList.slice(0, 11)
        },
        // Gets only our global related hotkeys and headers from the array
        globalHotKeys(): HotKeys[] {
            return this.hotKeysList.slice(11)
        },
        //  The 'turn on/off' toggle in the menu popup
        hotKeysEnabled(): object {
            // Find our hotKeysEnabled setting and return the boolean value determing if hotkeys are on or off
            let hotKeysEnabled = this.$store.getters.settingGet('hotKeysEnabled')

            return hotKeysEnabled
        }
    },
    methods: {
        // Close the app dialog that hosts this component
        close(): void {
            //  Hide the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        // Updates our hotKEysEnabled setting in our database, done here and not in set so we can async the change
        async enable(): Promise<void> {
            await this.$store.dispatch('settingsPut', this.hotKeysEnabled)
        }
    }
})
